export function backgroundImage(
  src: string,
): // @ts-expect-error - TS7030 - Not all code paths return a value.
| {
      backgroundImage: string;
    }
  | null
  | undefined {
  if (src) {
    return {
      backgroundImage: `url(${src})`,
    };
  }
}
